export const ERROR_MESSAGE_FASCIA_PLACEHOLDER = '<fascia>';

export enum ErrorMessage {
  API_ERROR = 'general:api.error',
  GENERAL = 'navigation:flyout.account.error.operation',
  GENERAL_ACCOUNT = 'account:account.error.general',
  GENERAL_VITALITY = 'dpe:dpe.vitality.error.general',
  GENERAL_ADDRESS_BUY = 'buy:buy.error.general.address',
  GENERAL_PAYMENT = 'buy:buy.payment.form.error',
  INVALID_PASSWORD = 'navigation:flyout.account.error.password',
  INVALID_EMAIL = 'buy:buy.login.email.error.invalid',
  REQUIRED = 'buy:buy.error.required',
  INVALID_STREET = 'general:address.error.streetName',
  MIN_LENGTH = 'general:error.minLength',
  SET_PASSWORD = 'navigation:flyout.account.error.set.password',
  LOCATION_BLOCKED = 'product:storeFinder.popup.blockedLocation',
  PASSWORD_MATCH = 'account:account.passwordMatch',
  INVALID_DATE = 'general:address.error.dateOfBirth',
  INVALID_PHONE = 'buy:buy.error.phone',
  INVALID_POSTAL_CODE_BE = 'general:address.error.postalCode.be',
  INVALID_POSTAL_CODE_NL = 'general:address.error.postalCode.nl',
  INVALID_POSTAL_CODE_DE_FR = 'general:address.error.postalCode.de.fr',
  INVALID_POSTAL_CODE_UK = 'general:address.error.postalCode.uk',
  INVALID_STREET_BE_LU = 'general:address.error.street.be.lu',
  INVALID_HOUSE_NUMBER_NL = 'general:address.error.houseNumber.nl',
  INVALID_HOUSE_NUMBER_BE_LU = 'general:address.error.houseNumber.be.lu',
  INVALID_HOUSE_NUMBER_ADDITION_BE_LU = 'general:address.error.houseNumberAddition.be.lu',
  INVALID_ADDRESS = 'buy:buy.error.address',
  INVALID_POSTAL_CODE = 'general:address.error.postalCode',
  ACCOUNT_MIN_LENGTH = 'account:account.minlength',
  ACCOUNT_REQUIRED = 'account:account.required',
  USER_UNKNOWN = 'navigation:flyout.account.error.email.unknown.user',
  USER_DEPRECATED_PLATFORM = 'navigation:flyout.account.deprecated.platform.description',
  GUEST_ACCOUNT_DOES_NOT_MATCH = 'account:account.return.login.guest.error',
  INVALID_VAT_NUMBER = 'account:account.patternVat',
  INVALID_PEPPOL_ID = 'account:account.patternPeppolID',

  // User unknown
  FLYOUT_USER_UNKNOWN = 'account:flyout.error.userUnknown',
  RETURN_PORTAL_USER_UNKNOWN = 'account:returnPortal.error.userUnknown',
  CHECKOUT_USER_UNKNOWN = 'account:checkout.error.userUnknown',
  REGISTRATION_COMPACT_USER_KNOWN = 'account:registrationCompact.error.userKnown',

  // User with password on other fascia
  FLYOUT_USER_KNOWN_OTHER_FASCIA = 'account:flyout.error.userKnown.otherFascia',
  REGISTRATION_USER_KNOWN_OTHER_FASCIA = 'account:registration.error.userKnown.otherFascia',
  CHECKOUT_LOGIN_USER_KNOWN_OTHER_FASCIA = 'account:checkout.login.error.userKnown.otherFascia',
  RETURN_PORTAL_LOGIN_USER_KNOWN_OTHER_FASCIA = 'account:returnPortal.login.error.userKnown.otherFascia',
  RETURN_PORTAL_REGISTRATION_USER_KNOWN_OTHER_FASCIA = 'account:returnPortal.registration.error.userKnown.otherFascia',
  CHECKOUT_REGISTRATION_USER_KNOWN_OTHER_FASCIA = 'account:checkout.registration.error.userKnown.otherFascia',
  LOGIN_FLOWS_USER_KNOWN_OTHER_FASCIA = `account:checkout.login.flows.step2.${ERROR_MESSAGE_FASCIA_PLACEHOLDER}.error.user.known.other.fascia`,

  // User without password
  FLYOUT_USER_KNOWN_SAME_FASCIA_NO_PASSWORD = 'account:flyout.error.userKnown.sameFascia.noPassword',
  REGISTRATION_USER_KNOWN_SAME_FASCIA_NO_PASSWORD = 'account:registration.error.userKnown.sameFascia.noPassword',
  CHECKOUT_LOGIN_USER_KNOWN_SAME_FASCIA_NO_PASSWORD = 'account:checkout.login.error.userKnown.sameFascia.noPassword',
  RETURN_PORTAL_LOGIN_USER_KNOWN_SAME_FASCIA_NO_PASSWORD = 'account:returnPortal.login.error.userKnown.sameFascia.noPassword',
  RETURN_PORTAL_REGISTRATION_USER_KNOWN_SAME_FASCIA_NO_PASSWORD = 'account:returnPortal.registration.error.userKnown.sameFascia.noPassword',
  CHECKOUT_REGISTRATION_USER_KNOWN_SAME_FASCIA_NO_PASSWORD = 'account:checkout.registration.error.userKnown.sameFascia.noPassword',
  LOGIN_FLOWS_USER_KNOWN_SAME_FASCIA_NO_PASSWORD = `account:checkout.login.flows.step2.${ERROR_MESSAGE_FASCIA_PLACEHOLDER}.error.user.known.same.fascia.no.password`,

  // User without password on other fascia
  FLYOUT_USER_KNOWN_OTHER_FASCIA_NO_PASSWORD = 'account:flyout.error.userKnown.otherFascia.noPassword',
  REGISTRATION_USER_KNOWN_OTHER_FASCIA_NO_PASSWORD = 'account:registration.error.userKnown.otherFascia.noPassword',
  RETURN_PORTAL_LOGIN_USER_KNOWN_OTHER_FASCIA_NO_PASSWORD = 'account:returnPortal.login.error.userKnown.otherFascia.noPassword',
  RETURN_PORTAL_REGISTRATION_USER_KNOWN_OTHER_FASCIA_NO_PASSWORD = 'account:returnPortal.registration.error.userKnown.otherFascia.noPassword',
  CHECKOUT_LOGIN_USER_KNOWN_OTHER_FASCIA_NO_PASSWORD = 'account:checkout.login.error.userKnown.otherFascia.noPassword',
  CHECKOUT_REGISTRATION_USER_KNOWN_OTHER_FASCIA_NO_PASSWORD = 'account:checkout.registration.error.userKnown.otherFascia.noPassword',

  // Wrong credentials
  FLYOUT_USER_KNOWN_WRONG_CREDENTIALS = 'account:flyout.error.userKnown.wrongCredentials',
  RETURN_PORTAL_LOGIN_USER_KNOWN_WRONG_CREDENTIALS = 'account:returnPortal.login.error.userKnown.wrongCredentials',
  CHECKOUT_LOGIN_USER_KNOWN_WRONG_CREDENTIALS = 'account:checkout.login.error.userKnown.wrongCredentials',
  CHECKOUT_V2_LOGIN_USER_KNOWN_WRONG_CREDENTIALS = 'checkout:checkout.login.error.user_known.wrong_credentials',

  // User known during registration / profile edit
  RETURN_PORTAL_REGISTRATION_USER_KNOWN = 'account:returnPortal.registration.error.userKnown',
  CHECKOUT_REGISTRATION_USER_KNOWN = 'account:checkout.registration.error.userKnown',
  REGISTRATION_USER_KNOWN = 'account:registration.error.userKnown',
  PROFILE_USER_KNOWN = 'account:profile.error.userKnown',

  // User known on other fascia
  REGISTRATION_USER_KNOWN_OTHER_FASCIA_SEND_LINK = 'account:registration.error.userKnown.otherFascia.send.link',

  // Login component
  LOGIN_USER_UNKNOWN = 'account:login.error.userUnknown',
}

export enum CheckoutErrorMessage {
  CHECKOUT_NOT_INITIATED = 'checkout.not.initiated',
  CHECKOUT_STEP_INVALID = 'checkout.step.invalid',
  BASKET_NOT_FOUND = 'basket.not.found',
  INVALID_EMAIL = 'invalid email',
}
